export function ChangeEquipamentoCards (cards, name){
    return{
        type: "ChangeEquipamentoCards",
        info: "ChangeEquipamentoCards",
        payload: {
            cards: cards,
            name: name
        }
    }
}

export function ChangeTotalCards (hasMoreCards){
    return{
        type: "ChangeTotalCards",
        info: "ChangeTotalCards",
        payload: { hasMoreCards: hasMoreCards }
    }
}

export function ChangeDays(days){
    return{
        type: "ChangeDays",
        info: "ChangeDays",
        payload: { days: days }
    }
}

export function ChangeDay (day){
    return{
        type: "ChangeDay",
        info: "ChangeDay",
        payload: { day: day }
    }
}

export function ChangeMonth (month){
    return{
        type: "ChangeMonth",
        info: "ChangeMonth",
        payload: { month: month }
    }
}

export function ListEquipamentos (equipamentos){
    return{
        type: "ListEquipamentos",
        info: "ListEquipamentos",
        payload: { equipamentos: equipamentos }
    }
}

export function ListCities(cities){
    return{
        type: "ListCities",
        info: "ListCities",
        payload: { cities: cities }
    }
}

export function ChangeCity(city){
    return{
        type: "ChangeCity",
        info: "ChangeCity",
        payload: { city: city }
    }
}

export function ChangeCardsLoading (isLoading){
    return{
        type: "ChangeCardsLoading",
        info: "ChangeCardsLoading",
        payload: { isLoading: isLoading }
    }
}

export function ChangeAutoplay (isAutoplayEnabled){
    return{
        type: "ChangeAutoplay",
        info: "ChangeAutoplay",
        payload: { isAutoplayEnabled: isAutoplayEnabled }
    }
}

export function ChangeDaysLoading (isLoading){
    return{
        type: "ChangeDaysLoading",
        info: "ChangeDaysLoading",
        payload: { isLoading: isLoading }
    }
}

export function changeyear (year){
    return{
        type: "changeyear",
        info: "changeyear",
        payload: { year: year }
    }
}

export function ChangeMode (mode){
    return{
        type: "ChangeMode",
        info: "ChangeMode",
        payload: { mode: mode }
    }
}

export function ChangeStatus (status){
    return{
        type: "ChangeStatus",
        info: "ChangeStatus",
        payload: { status: status }
    }
}

export function ChangeCardIcon (change){
    return{
        type: "ChangeCardIcon",
        info: "ChangeCardIcon",
        payload: { change: change }
    }
}

export function ChangeEquipment (equipment){
    return{
        type: "ChangeEquipment",
        info: "ChangeEquipment",
        payload: { equipment: equipment }
    }
}


